import { useState } from 'react';

import { navigate } from '../App.js';
import { lastTourId, loadSession } from '../lib/session.js';
import { pruefmodusAn, setPruefmodus } from '../lib/anzeige.js';
import { applyTheme, currentTheme, nextTheme, themeLabel } from '../lib/theme.js';

/**
 * Die Startseite.
 *
 * Wer schon in einer Ausfahrt war, kommt mit einem Tipp zurück hinein — das ist
 * der Fall nach einem Absturz, einem leeren Akku oder einem versehentlich
 * geschlossenen Browserfenster, und er soll der schnellste sein.
 */
export function StartPage(): React.JSX.Element {
  const letzte = lastTourId();
  const sitzung = letzte === null ? null : loadSession(letzte);
  const [thema, setThema] = useState(currentTheme);
  const [pruefmodus, setPruefmodusState] = useState(pruefmodusAn);

  return (
    <div className="seite">
      <h1>Konvoi</h1>
      <p>
        Alle Fahrzeuge der Ausfahrt auf einer Karte — und zurück zur Kolonne, wenn der Anschluss
        einmal reißt.
      </p>

      {sitzung !== null && (
        <>
          <h2>Weiterfahren</h2>
          {/*
            Der Name der Ausfahrt steht auf der Fläche selbst.

            Wer sein Gerät nach einer Woche wieder aufmacht, weiß sonst nicht,
            wohin ihn dieser Tipp bringt — und bei zwei Ausfahrten hintereinander
            erst recht nicht. Der Name kommt aus der gespeicherten Sitzung; bei
            Sitzungen aus einer früheren Fassung fehlt er noch und die Fläche
            bleibt einzeilig, bis die Ausfahrt einmal geladen wurde.
          */}
          <button
            type="button"
            className={`knopf knopf--wichtig${sitzung.tourName === null ? '' : ' knopf--zweizeilig'}`}
            onClick={() => {
              navigate(`/fahrt/${sitzung.tourId}`);
            }}
          >
            <span>Zurück zur Ausfahrt</span>
            {sitzung.tourName !== null && (
              <span className="knopf__zusatz">{sitzung.tourName}</span>
            )}
          </button>
        </>
      )}

      <h2>Mitfahren</h2>
      <button
        type="button"
        className="knopf"
        onClick={() => {
          navigate('/beitreten');
        }}
      >
        Ausfahrt beitreten
      </button>

      <h2>Darstellung</h2>
      <button
        type="button"
        className="knopf knopf--leise"
        onClick={() => {
          const neu = nextTheme(thema);
          applyTheme(neu);
          setThema(neu);
        }}
      >
        Darstellung: {themeLabel(thema)}
      </button>

      {/*
        Für Prüffahrten (A-139): zeigt während der Fahrt zusätzlich, was das
        Gerät selbst über sein Netz meldet. Hier und nicht in der Fahrt, weil
        man es vorher einschaltet — während der Fahrt wird nichts bedient, was
        nicht sein muss.
      */}
      <button
        type="button"
        className="knopf knopf--leise"
        aria-pressed={pruefmodus}
        onClick={() => {
          setPruefmodus(!pruefmodus);
          setPruefmodusState(!pruefmodus);
        }}
      >
        Prüfmodus: {pruefmodus ? 'an' : 'aus'}
      </button>
      {pruefmodus && (
        <p>Die Fahrt zeigt zusätzlich, wann das Gerät selbst „offline" meldet.</p>
      )}

      <h2>Für Organisatoren</h2>
      <button
        type="button"
        className="knopf knopf--leise"
        onClick={() => {
          navigate('/anlegen');
        }}
      >
        Neue Ausfahrt anlegen
      </button>
    </div>
  );
}
